import { useCreateEntityApi } from "@/common/api/createEntityApi";
import type { DashboardResponse } from "./common/dashboardResponse";
import type { DashboardComponetRequest } from "./common/dashboardComponentRequest";
import { useDashboardStore } from "../stores/dashboardStore";

export interface CreateDashboard {
  name: string;
  components: DashboardComponetRequest[];
}

export interface CreateDashboardResponse {
  ok: true;
  dashboard: DashboardResponse;
}

export function useCreateDashboardApi() {

  const store = useDashboardStore();

  return useCreateEntityApi<CreateDashboard, CreateDashboardResponse>({
    url: 'dashboard',
    translate: (t) => t.dashboard.actions.create,
    async processOk(response) {
      const json = await response.json() as DashboardResponse;
      store.add(json);
      return {
        ok: true,
        dashboard: json
      };
    },
  });
}
